import { Address } from '@dreryk/address-common-api';
import {
   CurrentDoctorAddressQuery,
   CurrentPractitionerQuery,
   PractitionerDetails,
} from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsFind, useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { personalDataTranslationKeys } from '../../../translations';

type PersonalDataFormLoaderRenderProps = {
   practitionerDetails: PractitionerDetails;
   doctorAddress?: Address;
};

type PersonalDataFormLoaderProps = {
   readonly children: (renderProps: PersonalDataFormLoaderRenderProps) => JSX.Element;
};

export const PersonalDataFormLoader = (props: PersonalDataFormLoaderProps): JSX.Element => {
   const updatingDoctorPersonalDataAvailable = protectFeature('updatingDoctorPersonalData');
   const {
      data: practitionerDetails,
      loading: practitionerDetailsLoading,
      error: practitionerDetailsError,
   } = useCqrsGet<PractitionerDetails>(() => new CurrentPractitionerQuery());

   const {
      data: currentDoctorAddress,
      loading: currentDoctorAddressLoading,
      error: currentDoctorAddressError,
   } = useCqrsFind<Address>(() => new CurrentDoctorAddressQuery(), {
      enabled: updatingDoctorPersonalDataAvailable,
   });

   if (practitionerDetailsLoading || currentDoctorAddressLoading) {
      return <LoaderSpinner />;
   }

   if (practitionerDetailsError || currentDoctorAddressError) {
      return (
         <Message
            testId={'failedToFetchPersonalData'}
            label={personalDataTranslationKeys.failedToFetchPersonalData}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      practitionerDetails: practitionerDetails,
      doctorAddress: currentDoctorAddress ?? undefined,
   });
};
